// SPDX-License-Identifier: AGPL-3.0-or-later

// Fork: the fork's API error codes. Upstream's APIErrorCodes takes them in by one spread, at the
// place they always had, so the codes and their order are unchanged.

export const ForkAPIErrorCodes = {
	UNKNOWN_PERSONA: 'UNKNOWN_PERSONA',
	PRIVATE_PERSONA: 'PRIVATE_PERSONA',
	PERSONA_LIMIT_REACHED: 'PERSONA_LIMIT_REACHED',
	DUPLICATE_PERSONA_TAG: 'DUPLICATE_PERSONA_TAG',
	PERSONA_TAG_LIMIT_REACHED: 'PERSONA_TAG_LIMIT_REACHED',
	DUPLICATE_SIGNATURE_EMOJI: 'DUPLICATE_SIGNATURE_EMOJI',
	SIGNATURE_EMOJI_LIMIT_REACHED: 'SIGNATURE_EMOJI_LIMIT_REACHED',
	UNKNOWN_GUILD_COMMAND: 'UNKNOWN_GUILD_COMMAND',
	GUILD_COMMAND_NAME_TAKEN: 'GUILD_COMMAND_NAME_TAKEN',
	GUILD_COMMAND_LIMIT_REACHED: 'GUILD_COMMAND_LIMIT_REACHED',
	GUILD_COMMAND_TEMPLATE_INVALID: 'GUILD_COMMAND_TEMPLATE_INVALID',
	GUILD_COMMAND_INPUT_INVALID: 'GUILD_COMMAND_INPUT_INVALID',
} as const;
